import { ObjectSchema, reach } from "yup"

export const isFieldRequired = (schema: ObjectSchema<any>, path: string) => {
  try {
    const required = reach(schema, path)
      .describe()
      .tests.some(test => test.name === "required")
    return required
  } catch (err) {
    return false
  }
}
